import './WifiConnectionStatus.css';

import React, { useEffect } from 'react';
import { useWifiNetworks } from '@src/contexts';
import { WifiOff, WifiOn } from '@src/assets';

interface WifiConnectionStatusProps {
  onClick?: (() => void) | undefined
}

export const WifiConnectionStatus = ({ onClick }: WifiConnectionStatusProps): JSX.Element => {
  const { connectedWifiNetwork, requestNetworkPolling } = useWifiNetworks();
  const isWifiConnected = Boolean(connectedWifiNetwork);

  useEffect(() => {
    return requestNetworkPolling();
  }, []);

  const className = onClick !== undefined ? 'wifi_connection_status_pointer' : '';
  return isWifiConnected
    ? <WifiOn onClick={onClick} className={className} />
    : <WifiOff onClick={onClick} className={className} />;
};
